// import * as lazysizes from 'lazysizes';
// import 'lazysizes/plugins/respimg/ls.respimg';
// import 'lazysizes/plugins/parent-fit/ls.parent-fit';
// import 'lazysizes/plugins/object-fit/ls.object-fit';

import { Video } from './Video';

new Video();
